<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="columns">
    <div class="column is-12">
      <h1
        class="title is-2 has-text-weight-bold has-line"
        id="incentive-database-h1"
      >
        Find incentives
      </h1>

      <p>
        This interactive tool allows you to find R&D tax incentives with
        specific features and create a selection of incentives for review and
        comparison.
      </p>
    </div>
  </div>
</div>
<div class="container">
  <div class="columns is-multiline">
    <div class="column is-12 pb-0">
      <div
        class="card has-background-white-ter is-shadowless p-4 is-fullheight card--filters"
      >
        <nav class="level is-mobile mb-3">
          <div class="level-left">
            <div class="level-item">
              <p class="content is-small has-text-weight-bold">Filters</p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item" *ngIf="activeOptions.length">
              <a
                (click)="clearAllForm()"
                class="is-size-7 mr-4 has-text-dark is-underlined"
                >Clear all</a
              >
            </div>
            <div class="level-item">
              <div class="field has-addons">
                <p class="control">
                  <a class="button is-small is-hidden-desktop">
                    <span class="icon is-small">
                      <i class="fa-solid fa-sliders"></i>
                    </span>
                  </a>
                  <a
                    class="button is-small is-hidden-touch"
                    (click)="showAdvancedFilters = !showAdvancedFilters"
                  >
                    <span>Advanced filters</span>
                    <span class="icon is-small">
                      <i class="fa-solid fa-sliders"></i>
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </nav>
        <form [formGroup]="form">
          <div class="columns is-multiline pb-4" *ngIf="!loadingFilters">
            <ng-container *ngFor="let filter of filters">
              <div
                class="column is-4-tablet is-3-desktop pb-0"
                *ngIf="filter.type === 'basic'"
              >
                <app-multi-select-input
                  [label]="filter.label"
                  [options]="filter.options"
                  [activeOptions]="filter.activeOptions"
                  (valueChanged)="onFilterChange(filter.fieldId, $event)"
                ></app-multi-select-input>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="!loadingFilters && showAdvancedFilters === true">
            <nav class="level is-mobile mb-3">
              <div class="level-left">
                <div class="level-item">
                  <p class="content is-small has-text-weight-bold">
                    Advanced Filters
                  </p>
                </div>
              </div>
            </nav>
            <div
              class="columns is-multiline pb-4"
              *ngIf="!loadingFilters && showAdvancedFilters === true"
            >
              <ng-container *ngFor="let filter of filters">
                <div
                  class="column is-4-tablet is-3-desktop pb-0"
                  *ngIf="filter.type === 'advanced'"
                >
                  <app-multi-select-input
                    [label]="filter.label"
                    [options]="filter.options"
                    [activeOptions]="filter.activeOptions"
                    (valueChanged)="onFilterChange(filter.fieldId, $event)"
                  ></app-multi-select-input>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <app-filter-loader *ngIf="loadingFilters"> </app-filter-loader>
        </form>
      </div>
    </div>

    <!-- Active options -->
    <div class="column is-12">
      <div class="field is-grouped is-grouped-multiline">
        <span
          class="tag is-white is-rounded mr-1 mb-1 has-text-weight-bolds is-bordered is-medium"
          *ngFor="let activeOption of activeOptions"
        >
          <strong *ngIf="activeOption.filterId === 'similarTo'"
            >Similar to:</strong
          >
          <span class="pl-1">{{ activeOption.value }}</span>
          <button
            class="delete ml-1"
            (click)="clearOption(activeOption.filterId, activeOption.value)"
          ></button>
        </span>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="!incentives?.length && !loadingIncentives">
  <div class="container">
    <div class="columns">
      <div class="column is-12 has-text-centered">
        <div class="card has-background-warning-light mb-8 p-8">
          <i
            class="fa-regular fa-folder-open is-size-2 has-text-grey-light mb-4"
          ></i>
          <h4 class="mb-0">There are no results for your search.</h4>
          <p class="mt-3">Try to remove some filters to expand your search.</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div
  class="container m-t-alt mb-6"
  *ngIf="incentives?.length && !loadingIncentives"
>
  <div class="columns">
    <div class="column is-12">
      <nav class="level is-mobile mb-2">
        <div class="level-left">
          <div class="level-item">
            <p class="content is-small has-text-weight-bold mb-0">
              {{ incentives.length }} incentives found
            </p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div
              class="dropdown is-right"
              [ngClass]="{ 'is-active': showExportMenu }"
            >
              <div class="dropdown-trigger">
                <button
                  class="button is-small is-link-light"
                  [ngClass]="{ 'is-loading': loadingDownload }"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  (click)="showExportMenu = !showExportMenu"
                >
                  <span class="is-hidden-touch">Export</span>
                  <i class="fa-solid fa-file-export is-hidden-desktop"></i>
                  <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                  <a
                    class="dropdown-item"
                    (click)="downloadIncentives(incentives)"
                    [attr.disabled]="loadingDownload ? true : null"
                  >
                    The result ({{ incentives.length }} incentives)
                  </a>
                  <a
                    class="dropdown-item"
                    (click)="downloadIncentives([])"
                    [attr.disabled]="loadingDownload ? true : null"
                  >
                    All the incentives (heavy download)
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="card is-shadowless table-container mt-2 mb-8">
        <div
          class="scrollbar-wrapper"
          (scroll)="onScroll($event, 'top')"
          #scrollBarWrapper
        >
          <div class="scrollbar-child" #scrollBarChild></div>
        </div>
        <div
          class="table-container"
          #tableContainer
          (scroll)="onScroll($event, 'bottom')"
        >
          <table class="table is-fullwidth content is-small">
            <thead>
              <tr class="has-background-white-ter">
                <th>
                  <label
                    class="checkbox is-flex is-align-items-center mr-2 content is-small pl-0"
                  >
                    <!-- TODO: Style. Creates small layout break when not displayed -->
                    <input
                      type="checkbox"
                      class="mr-1 has-tooltip-hidden-tablet has-tooltip-right has-tooltip-hidden-mobile"
                      data-tooltip="Select all for comparison"
                      (click)="toggleAllFavorites(incentives)"
                      [checked]="isAllFavorites"
                      *ngIf="activeOptions.length"
                    />
                    <span
                      [ngClass]="{
                        'ml-2': activeOptions.length,
                        'simulate-space': !activeOptions.length
                      }"
                      >Incentive</span
                    >
                  </label>
                </th>
                <th
                  *ngFor="let column of tableColumns"
                  class="has-tooltip has-tooltip-bottom"
                  [title]="column.label"
                >
                  <span> {{ column.label | truncate : [20] }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let incentive of incentives"
                [ngClass]="{
                  'is-active': isFavorite(incentive),
                  'is-disabled': incentive.isDisabled
                }"
              >
                <td>
                  <div
                    class="is-flex is-align-items-center is-justify-content-flex-start"
                  >
                    <app-favorite-button
                      [incentive]="incentive"
                      [compact]="true"
                    ></app-favorite-button>
                    <div
                      class="flag-wrapper mr-1 has-tooltip-hidden-tablet has-tooltip-right has-tooltip-hidden-mobile is-flex is-align-items-center is-justify-content-center"
                      [attr.data-tooltip]="incentive.country.label"
                    >
                      <img
                        class="flag is-small"
                        src="./assets/images/flags/{{
                          incentive.country.image
                        }}.png"
                        alt="{{ incentive.country.label }} flag"
                        [routerLink]="['/incentives', incentive.id]"
                      />
                    </div>
                    <span class="incentive-id">
                      <a [routerLink]="['/incentives', incentive.id]">
                        {{ incentive.label }}</a
                      >
                    </span>
                  </div>
                </td>

                <td *ngFor="let column of tableColumns">
                  <span>
                    {{
                      incentive.values[column.fieldId] | truncate : [80]
                    }}</span
                  >
                  <span *ngIf="!incentive.values[column.fieldId]">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-incentive-loader *ngIf="loadingIncentives"> </app-incentive-loader>
